module.exports = __webpack_public_path__ + "static/img/2_1_3.02014836.jpg";